(() => {
  const desktop = window.matchMedia('(min-width: 1000px)');
  function layout(frame) {
    frame.contentWindow?.postMessage({ type: 'trustpilot:layout', desktop: desktop.matches }, window.location.origin);
  }
  function init(root) {
    root.querySelectorAll('.mc-trustpilot-frame').forEach(frame => {
      if (frame.dataset.initialized) return;
      frame.dataset.initialized = 'true';
      frame.addEventListener('load', () => layout(frame));
      layout(frame);
      const section = frame.closest('.shopify-section');
      section?.querySelectorAll('.reviews-slider__button').forEach(button => {
        button.addEventListener('click', () => frame.contentWindow?.postMessage({
          type: 'trustpilot:scroll', direction: button.classList.contains('reviews-slider__button--next') ? 1 : -1
        }, window.location.origin));
      });
    });
    root.querySelectorAll('[data-trustpilot-expires]').forEach(badge => {
      const remaining = Number(badge.dataset.trustpilotExpires) * 1000 - Date.now();
      const expire = () => { badge.textContent = badge.dataset.trustpilotFallback || 'Trustpilot'; };
      if (remaining <= 0) expire();
      else setTimeout(expire, Math.min(remaining, 86400000));
    });
  }
  window.addEventListener('message', event => {
    if (event.origin !== window.location.origin || event.data?.type !== 'trustpilot:ready') return;
    document.querySelectorAll('.mc-trustpilot-frame').forEach(frame => {
      if (frame.contentWindow === event.source) layout(frame);
    });
  });
  desktop.addEventListener('change', () => document.querySelectorAll('.mc-trustpilot-frame').forEach(layout));
  document.addEventListener('shopify:section:load', event => init(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
})();
